// extracted by mini-css-extract-plugin
module.exports = {"__filled_up_arrow":"FilledArrow___filled_up_arrow__3y857","__filled_down_arrow":"FilledArrow___filled_down_arrow__2YrSj"};